/**
 * Nunjucks is passing the options arguments into args as a dictionary (for whatever reason)
 */
/* eslint-disable complexity */
export function contextUrl(state,
    absoluteURL = false,
    excludeContextPath = false,
    staticURL = false,
    staticLibURL = false) {

    const c = state || this.ctx.core;

    if (absoluteURL) {
        return `${_.get(c, 'constants.urls.canonical', '').trim()}${_.get(c, 'contextPath', '/')}`;
    } else if (staticURL) {
        return `/static/${String(_.get(c, 'constants.version', '/')).trim()}`;
    } else if (staticLibURL) {
        return '/static/lib/';
    } else if (excludeContextPath) {
        return '/';
    }

    return _.get(c, 'contextPath', '/').trim();
}
